import React, { useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import $ from "jquery";

const Sidebar = ({ icon }) => {
    const navigate = useNavigate();
    useEffect(() => {
        axios.get("/auth/auth").then((res) => {
            if (!res.data) {
                navigate('/login')
            }
        });
    }, []);

    return (
        <nav className="sidebar">
            <div className="sidebar-header">
                <Link to="/" className="sidebar-brand">
                    Sar<span>dam</span>
                </Link>
                <div className="sidebar-toggler not-active" onClick={() => {
                    $('.sidebar-header .sidebar-toggler').toggleClass('active not-active');
                    if (window.matchMedia('(min-width: 992px)').matches) {
                        $('body').toggleClass('sidebar-folded');
                    } else if (window.matchMedia('(max-width: 991px)').matches) {
                        $('body').toggleClass('sidebar-open');
                    }
                    $(".sidebar .sidebar-body").on('hover', () => {
                        if ($('body').hasClass('sidebar-folded')) {
                            $('body').addClass("open-sidebar-folded");
                        }
                    }, () => {
                        if ($('body').hasClass('sidebar-folded')) {
                            $('body').removeClass("open-sidebar-folded");
                        }
                    });
                }}>
                    <span />
                    <span />
                    <span />
                </div>
            </div>
            <div className="sidebar-body">
                <ul className="nav">
                    <li className="nav-item">
                        <Link to="/blog" className="nav-link">
                            <icon.Info className="link-icon" />
                            <span className="link-title">Blog</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/doctors" className="nav-link">
                            <icon.Users className="link-icon" />
                            <span className="link-title">Doctors</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/sliders" className="nav-link">
                            <icon.Image className="link-icon" />
                            <span className="link-title">Sliders</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/departments" className="nav-link">
                            <icon.Layers className="link-icon" />
                            <span className="link-title">Department</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/specialists" className="nav-link">
                            <icon.FileText className="link-icon" />
                            <span className="link-title">Specialist</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/intro" className="nav-link">
                            <icon.Flag className="link-icon" />
                            <span className="link-title">Intro</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/general" className="nav-link">
                            <icon.Globe className="link-icon" />
                            <span className="link-title">General</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/users" className="nav-link">
                            <icon.User className="link-icon" />
                            <span className="link-title">Users</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/gallery" className="nav-link">
                            <icon.Image className="link-icon" />
                            <span className="link-title">Gallery</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Sidebar;